import React, { Component } from 'react'
import PageBuilderAddElements from './PageBuilderAddElements'
import PageBuilderAddElements2 from './PageBuilderAddElements2'
import PageBuilderHeader from './PageBuilderHeader'
import PageBuilderMain from './PageBuilderMain'
import { formBuilderGroups, FormBuilderObjects } from '../variables/formBuilderData'
import { widgetsList, widgetsGroups } from '../variables/widgetsList'
import inputComponents from '../components/inputs/inputComponents'
import WidgetComponents from '../components/widgets/WidgetComponents'
import ButtonAnimated from '../components/buttons/ButtonAnimated'
import HttpServices from '../utils/Http.services'
import Modal from '../components/Modal'
import { translate } from '../utils/useful'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import importedIcons from '../components/inputs/icons'
// import { FormBuilderObjects } from '../variables/formBuilderData';

class PageViewer extends Component {
    state = {
        type: 'dashboard',
        componentsInfo: {
            form: { object: FormBuilderObjects, groups: formBuilderGroups, components: inputComponents },
            dashboard: { object: widgetsList, groups: widgetsGroups, components: WidgetComponents },
        },

    }

    componentDidMount() {
        this.init(true)

        // console.log("PageViewer componentDidMount")

        // if (this.props.setHeader) {
        //     this.props.setHeader({
        //         // 'toolbar': null,
        //         'showToolbar': false,
        //         topHeaderComponent: this.topHeaderComponent,
        //         headerIdentityComponent: this.headerIdentityComponent,
        //         backAction: () => { this.props.changePage(''); console.log('backkkkkkkkkkkkkkkk') }

        //     })
        // }
    }
    componentDidUpdate(prevProps) {


        if (this.props.windowData?.path[this.props.baseUrl?.length] != prevProps.windowData?.path[this.props.baseUrl?.length]) {
            this.init(true)
        }
        if ((this.props.page ? JSON.stringify(this.props.page?._id) : null) != (this.state.page ? JSON.stringify(this.state.page?._id) : null)) {

            // console.log('this.props.page', this.props.page, this.state.page)
            this.init()
        }
    }
    // init = () => {
    //     let _id = this.props.windowData?.path[this.props.baseUrl?.length]
    //     console.log('get Page', this.props.applet)
    //     // console.log(_id)
    //     if (_id != "new" && _id != null) {

    //         // GET PAGE
    //         HttpServices.request('getFrame', { _id: _id }, (fetchResult, fetchError) => {
    //             console.log('fethcresult1-', fetchResult.info)
    //             this.setState({ _id: _id, initData: fetchResult.info.page, name: fetchResult.info.name }, () => {

    //                 // this.props.setHeader("dummy",1)
    //             })
    //         })
    //     }
    //     else if (this.props.applet?.page) {
    //         HttpServices.request('getFrame', { _id: this.props.applet.page?._id }, (fetchResult, fetchError) => {
    //             console.log('fethcresult1-', fetchResult.info)
    //             this.setState({ _id: _id, initData: fetchResult.info.page, name: fetchResult.info.name }, () => {
    //                 if (this.props.setHeader) {
    //                     this.props.setHeader("dummy", 1)
    //                 }
    //             })
    //         })
    //         // this.setState({ _id: this.props.applet?.page._id, initData: this.props.applet?.page.page, name: this.props.applet?.page.name }, () => {
    //         //     this.props.setHeader("dummy", 1)
    //         //     console.log('this.props.applet?.page', this.props.applet?.page)
    //         // })
    //     }
    // }
    init(force) {

        // console.log('init', this.props.page)
        // TO DO: CHECK IF THE FUNCTION IS LOADING MORE THAN ONCE
        if (this.props.page || force) {
            // console.log("PageViewer init")

            // console.log('initdwqd',this.props.windowData?.path[this.props.baseUrl?.length])
            this.setState({ view: false, page: { ...this.props.page } }, () => {
                this.setState({ view: true }, () => {


                    let _id = this.props.windowData?.path[this.props.baseUrl?.length]


                    if(!_id && this.props.page){
                        _id = this.props.page?._id
                    }
                    //  console.log('get Page', this.props.windowData?.path,this.props.baseUrl,_id, this.props.page?._id)

                    if (_id != "new" && _id != null) {
                        // GET PAGE

                        // console.log('getFrame',_id)

                        HttpServices.request('getFrame', { _id: _id }, (fetchResult, fetchError) => {


                            // console.log(fetchError,fetchResult)

                            if (fetchError || !fetchResult || !fetchResult.info) {
                                return
                            }

                            this.setState({ _id: _id, initData: fetchResult.info.page, name: fetchResult.info.name, page: fetchResult?.info }, () => {
                                // if (this.props.setHeader) {

                                //     this.props.setHeader("dummy", 1)
                                // }
                            })
                            if (fetchResult?.info?.config?.fetches) {
                                this.getSingleContent(fetchResult?.info)
                            }
                        })
                    }
                    else if (this.props.applet?.page) {

                        HttpServices.request('getFrame', { _id: this.props.applet.page?._id }, (fetchResult, fetchError) => {

                            if (fetchError || !fetchResult || !fetchResult.info) {
                                return
                            }

                            this.setState({ _id: _id, initData: fetchResult.info.page, name: fetchResult.info.name, page: fetchResult?.info }, () => {
                                // if (this.props.setHeader) {

                                //     this.props.setHeader("dummy", 1)
                                // }
                            })
                            // console.log('fetchResult?.info', fetchResult)

                            if (fetchResult?.info?.config?.fetches) {
                                this.getSingleContent(fetchResult?.info)
                            }
                        })
                        //         HttpServices.request('getFrame', { _id: this.props.applet.page?._id }, (fetchResult, fetchError) => {
                        //             console.log('fethcresult1-', fetchResult.info)
                        //             this.setState({ _id: _id, initData: fetchResult.info.page, name: fetchResult.info.name }, () => {
                        //                 if (this.props.setHeader) {
                        //                     this.props.setHeader("dummy", 1)
                        //                 }
                        //             })
                        //         })
                        //         // this.setState({ _id: this.props.applet?.page._id, initData: this.props.applet?.page.page, name: this.props.applet?.page.name }, () => {
                        //         //     this.props.setHeader("dummy", 1)
                        //         //     console.log('this.props.applet?.page', this.props.applet?.page)
                        //         // })
                    } else if (this.props.page) {
                        // console.log('ondashboardhere', this.props.page)
                        this.setState({ _id: _id, initData: this.props.page.page, name: this.props.page.name, page: this.props.page }, () => {
                            // if (this.props.setHeader) {

                            //     this.props.setHeader("dummy", 1)
                            // }
                        })

                        if (this.props.page?.config?.fetches) {
                            this.getSingleContent(this.props.page)
                        }

                    }
                    // if (this.props.setHeader) {
                    //     this.props.setHeader({
                    //         'toolbar': null,
                    //         'showToolbar': false,
                    //         topHeaderComponent: this.topHeaderComponent,
                    //         headerIdentityComponent: this.headerIdentityComponent,
                    //         backAction: () => this.props.changePage(['settings', 'pages'])
                    //     })
                    // }

                })
            })
        }

    }


    // functionsHandler = (type, name, data, extra) => {
    //     if (this[name]) {
    //         this[name](data, extra)
    //     }
    // }
    getSingleContent(info) {
        // console.log('getSingleContent')
        let _id = this.props.windowData?.path[this.props.baseUrl?.length + 1]
        if (!_id) {
            _id = info._id
        }
        let fetchInfo = info?.config?.fetches

        // console.log("getSingleContent")
        // console.log("getSingleContent")

        if (Array.isArray(fetchInfo)) {

            let promises = []
            let fetchedData = []
            let params = []

            info?.config?.fetches.forEach(fetchInfo => {

                promises.push(new Promise((resolve) => {

                    if (_id && fetchInfo) {

                        HttpServices.request('getSingleRecord', { id: _id, collection: fetchInfo.collection }, (fetchResult, fetchError) => {

                            resolve()

                            if (fetchError) {
                                return
                            }


                            let fInfo = fetchInfo
                            fInfo.info = fetchResult.info
                            fInfo.frame = fetchResult.frame

                            fetchedData.push(fInfo)


                            let param = { applet: this.props.applet, label: fetchInfo.name, value: fetchInfo.value, fields: fetchResult.frame?.fields, info: fetchResult.info, current: fetchResult.current, allQuizes: fetchResult.allQuizes }

                            params.push(param)
                        })

                    } else {
                        resolve()
                    }

                }))




            });


            // promises.push(new Promise((resolve) => {

            //     if (_id && fetchInfo) {

            //         HttpServices.request('getVariables', { id: _id, collection: fetchInfo.collection }, (fetchResult, fetchError) => {

            //             resolve()

            //             if (fetchError) {
            //                 return
            //             }

            //             console.log(fetchResult)
            //             let fInfo = fetchInfo
            //             fInfo.info = fetchResult.info
            //             fInfo.frame = fetchResult.frame

            //             fetchedData.push(fInfo)

            //         })

            //     } else {
            //         resolve()
            //     }

            // }))


            Promise.all(promises).then(() => {

                this.setState({ fetchedData, params })
                console.log('fetchedData, params', fetchedData, params)
            })

        }


    }
    setData = (key, value, reference, cb) => {
        if (reference == 'PageBuilder') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {

                })
            }
        }
    }

    // topHeaderComponent = () => {
    //     return (
    //         <div className='flexc'>
    //             <div className='px-2'>
    //                 <PageBuilderAddElements type={this.state.type} componentsInfo={this.state.componentsInfo[this.state.type]} onDragStartAction={this.onDragStartAction} applet={this.props.applet} />
    //             </div>

    //             <ButtonAnimated
    //                 iconwidth='24px'
    //                 onClick={this.savePage}
    //                 title='Save'
    //                 icon='/assets/icons/plus-white.svg'
    //                 textColor={this.props.colors?.iconInvert ? '#fff' : '#000'}
    //                 invert={!this.props.colors?.iconInvert}
    //                 bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
    //             // border={''}
    //             />

    //         </div>
    //         // <button className='br-20 px-2 py-1' style={{backgroundColor:'#fff'}}>
    //         //     <p>Save</p>
    //         // </button>
    //     )
    // }
    // headerIdentityComponent = () => {
    //     return (
    //         <div className='' >
    //             <input onChange={(e) => this.setName(e.target.value)} value={this.state.name} className={' ' + this.props.colors?.iconInvert ? 'lightPlaceholder' : 'darkPlaceholder'} style={{ fontSize: '18px', backgroundColor: 'transparent', border: 'none', color: this.props.colors.textColor }} placeholder={translate('insert name ...')} />
    //         </div>
    //         // <button className='br-20 px-2 py-1' style={{backgroundColor:'#fff'}}>
    //         //     <p>Save</p>
    //         // </button>
    //     )
    // }
    setName = (value) => {
        this.setState({ name: value })
    }

    // savePage = () => {
    //     console.log('savePag1', this.state.name)
    //     let content = this.PageBuilderMain.state.content

    //     if (!this.state.name) {
    //         // this.nameModal.showModal()
    //         return
    //     }

    //     let data = {
    //         _id: this.state._id,
    //         type: 'page',
    //         page: content,
    //         applet: this.props.variables.appletId
    //     }

    //     // console.log(data)
    //     this.setState({ data }, () => {
    //         console.log('page', this.props.page)
    //         let page = this.props.page


    //         let isEditing = data._id ? true : false
    //         let address = "postPage"//isEditing ? (page.editUrl ?? page.addUrl) : page.addUrl
    //         // data.page = this.props.page?.key
    //         this.setState({ isPostingData: true })

    //         if (page.postBody) {
    //             data = { ...data, ...page.postBody }
    //         }

    //         for (const [key, value] of Object.entries(data)) {
    //             if (/\{\{(.*?)\}\}/.test(value)) {

    //                 if (this.props.variables) {
    //                     data[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
    //                 }
    //             }
    //         }
    //         // data.frame = this.state.currentFrame?._id
    //         // data.features = this.props.applet.features
    //         data.name = this.state.name
    //         console.log('address', address)
    //         console.log('data', data)
    //         HttpServices.request(address, data, (fetchResult, fetchError) => {
    //             if (fetchError) {
    //                 this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postFailed', description: fetchError.message })
    //                 return
    //             }
    //             // console.log([...this.props.baseUrl])


    //             let newLink = this.props.baseUrl.splice(2)
    //             newLink.push(fetchResult?.info?._id)
    //             // console.log(newLink)

    //             // this.props.changeWindowLink(newLink)
    //             this.setState({ _id: fetchResult?.info?._id })
    //             // console.log(fetchResult)
    //             this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postedSuccesfully', description: '{{lang}}info.dataSavedSuccessfully' })



    //         })
    //     })

    // }

    functionsHandler = (type, name, data, extra, cb) => {

        console.log("functionsHandler", type, name, data, extra)

        if (!type || type == 'frame' || type == 'collection') {
            if (this[name]) {
                this[name](data, extra, cb)
            } else {
                this.props.functionsHandler(type, name, data, extra, cb)
            }
        } else {
            this.props.functionsHandler(type, name, data, extra, cb)
        }
    }


    onDragStartAction = (e) => {
        this.PageBuilderMain.onDragStartAction(e)
    }

    render() {

        let background = this.props.colors ? `linear-gradient(90deg, ${this.props.colors?.primaryColor}, ${this.props.colors?.secondaryColor})` : 'linear-gradient(to right, #5856D6, #7D7AFF)'


        return (
            <div className='w-100 d-flex window-content-radius h-100 ' >
                <div className='w-100 h-100'>
                    {/* <div className='w-100 posittion-sticky top-0'>
                        <PageBuilderHeader type={this.state.type} componentsInfo={this.state.componentsInfo[this.state.type]} getPage={this.getPage} />
                    </div> */}
                    {/* <div className='w-100 posittion-sticky top-0'>
                        <PageBuilderAddElements2 />
                    </div> */}
                    <div className='w-100 h-100'>
                        <PageBuilderMain page={this.state.page} permissions={this.props.permissions} userView={this.props.userView} baseUrl={this.props.baseUrl} windowData={this.props.windowData} functionsHandler={this.functionsHandler} setHeader={this.props.setHeader} changeWindow={this.props.changeWindow} params={this.state.params} initData={this.state.initData} componentsInfoForm={this.state.componentsInfo['form']} type={this.state.type} componentsInfo={this.state.componentsInfo[this.state.type]} ref={el => this.PageBuilderMain = el} width={this.props.width} height={this.props.height} colors={this.props.colors ?? {}} changeWindowLink={this.props.changeWindowLink} pageChangePage={this.props.pageChangePage} applet={this.props.applet} editMode={false} addNewWindow={this.props.addNewWindow} padding={'10px 10px'} name={this.state.name} showToolbar={this.props.showToolbar} />
                        {/* <PageBuilderMain baseUrl={this.props.baseUrl} windowData={this.props.windowData} functionsHandler={this.props.functionsHandler} setHeader={this.props.setHeader} changeWindow={this.props.changeWindow} initData={this.state.initData} params={this.state.params} componentsInfoForm={this.state.componentsInfo['form']} type={this.state.type} componentsInfo={this.state.componentsInfo[this.state.type]} ref={el => this.PageBuilderMain = el} width={this.props.width} height={this.props.height} colors={this.props.colors} changeWindowLink={this.props.changeWindowLink} changePage={this.props.changePage} pageChangePage={this.props.pageChangePage} applet={this.props.applet} editMode={true} /> */}

                    </div>
                    {/* <div style={{ position: "fixed", bottom: "10px", left: "10px", zIndex: 10 }}>
                        <PageBuilderAddElements type={this.state.type} componentsInfo={this.state.componentsInfo[this.state.type]} onDragStartAction={this.onDragStartAction} />
                    </div> */}

                    {/* <Modal ref={el => this.nameModal = el} maxWidth={350}>
                        <div className='px-4 py-4 shadow-3 br-8 d-flex flex-column' style={{ backgroundColor: '#fff', }}>
                            <p className='text-semibold text-normal'>{translate("Please Insert a name for the page")}</p>
                            <p className='text-small'>{translate("So you can identify it later")}</p>

                            <div className='modern-input mt-3'>
                                <input className=' br-4 transpanet-input' onChange={(e) => this.setName(e.target.value)} placeholder={translate('Name ...')} />
                            </div>
                            <div className='flexcc mt-2 '>
                                <ButtonAnimated
                                    iconwidth='24px'
                                    onClick={this.savePage}
                                    title='Save'
                                    icon='/assets/icons/plus-white.svg'
                                    textColor={this.props.colors?.textColor}
                                    invert={this.props.colors?.iconInvert}
                                    bg={background}
                                />

                            </div>
                        </div>
                    </Modal> */}
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PageViewer);